var _rect, _rect2, _rect3, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiSurvey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 38 23",
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 22.987,
    y: 0.667,
    width: 5.347,
    height: 11.879,
    rx: 1,
    fill: "#A8FFF8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.333,
    y: 6.667,
    width: 6.667,
    height: 6.667,
    rx: 3.333,
    fill: "#CBFF88"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 9.708,
    y: 14.75,
    width: 4,
    height: 4,
    rx: 2,
    fill: "#CBFF88"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.708 9.269h14v3.398l-1.833 1.875-2.042 2.208H11.708V9.269z",
    fill: "#14454C",
    fillOpacity: 0.15
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.42 11.835V2.914H14.246v12.174h8.921a.29.29 0 010 .58h-9.21a.29.29 0 01-.29-.29V2.623c0-.16.13-.29.29-.29H26.71c.16 0 .29.13.29.29v9.21a.29.29 0 01-.58 0z",
    fill: "#14454C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.995 8.087l1.921 1.92 4.755-4.754a.29.29 0 11.41.41l-4.96 4.96a.29.29 0 01-.41 0l-2.125-2.126a.29.29 0 01.41-.41zM26.71 11.545a.29.29 0 01.205.495l-3.543 3.542a.29.29 0 01-.494-.205v-3.542c0-.16.13-.29.29-.29h3.542zm-3.253 3.133l2.553-2.553h-2.553v2.553z",
    fill: "#14454C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 0l.99 2.51L38 3.5l-2.51.99L34.5 7l-.99-2.51L31 3.5l2.51-.99L34.5 0zM3.5 16l.99 2.51L7 19.5l-2.51.99L3.5 23l-.99-2.51L0 19.5l2.51-.99L3.5 16z",
    fill: "#14D1C2"
  })));
}
export default __webpack_public_path__ + "fonts/ai-survey-c592373a1410172d16e6abe5da18d4df.svg";
export { SvgAiSurvey as ReactComponent };